import { ProfilePreferredRole } from '@platform/data-access'
import type { Country as CountryCode } from 'react-phone-number-input'

type CountryInfo = {
  [country in CountryCode]: {
    code: CountryCode
    name: string
  }
}

export const COUNTRY_LIST: CountryInfo = {
  AC: { code: 'AC', name: 'Ascension' },
  AF: { code: 'AF', name: 'Afghanistan' },
  AX: { code: 'AX', name: 'Aland Islands' },
  AL: { code: 'AL', name: 'Albania' },
  DZ: { code: 'DZ', name: 'Algeria' },
  AS: { code: 'AS', name: 'American Samoa' },
  AD: { code: 'AD', name: 'Andorra' },
  AO: { code: 'AO', name: 'Angola' },
  AI: { code: 'AI', name: 'Anguilla' },
  AG: { code: 'AG', name: 'Antigua And Barbuda' },
  AR: { code: 'AR', name: 'Argentina' },
  AM: { code: 'AM', name: 'Armenia' },
  AW: { code: 'AW', name: 'Aruba' },
  AU: { code: 'AU', name: 'Australia' },
  AT: { code: 'AT', name: 'Austria' },
  AZ: { code: 'AZ', name: 'Azerbaijan' },
  BS: { code: 'BS', name: 'Bahamas' },
  BH: { code: 'BH', name: 'Bahrain' },
  BD: { code: 'BD', name: 'Bangladesh' },
  BB: { code: 'BB', name: 'Barbados' },
  BY: { code: 'BY', name: 'Belarus' },
  BE: { code: 'BE', name: 'Belgium' },
  BZ: { code: 'BZ', name: 'Belize' },
  BJ: { code: 'BJ', name: 'Benin' },
  BM: { code: 'BM', name: 'Bermuda' },
  BT: { code: 'BT', name: 'Bhutan' },
  BO: { code: 'BO', name: 'Bolivia' },
  BQ: { code: 'BQ', name: 'Bonaire, Saint Eustatius and Saba' },
  BA: { code: 'BA', name: 'Bosnia And Herzegovina' },
  BW: { code: 'BW', name: 'Botswana' },
  BR: { code: 'BR', name: 'Brazil' },
  IO: { code: 'IO', name: 'British Indian Ocean Territory' },
  BN: { code: 'BN', name: 'Brunei Darussalam' },
  BG: { code: 'BG', name: 'Bulgaria' },
  BF: { code: 'BF', name: 'Burkina Faso' },
  BI: { code: 'BI', name: 'Burundi' },
  KH: { code: 'KH', name: 'Cambodia' },
  CM: { code: 'CM', name: 'Cameroon' },
  CA: { code: 'CA', name: 'Canada' },
  CV: { code: 'CV', name: 'Cape Verde' },
  KY: { code: 'KY', name: 'Cayman Islands' },
  CF: { code: 'CF', name: 'Central African Republic' },
  TD: { code: 'TD', name: 'Chad' },
  CL: { code: 'CL', name: 'Chile' },
  CN: { code: 'CN', name: 'China' },
  CX: { code: 'CX', name: 'Christmas Island' },
  CC: { code: 'CC', name: 'Cocos (Keeling) Islands' },
  CO: { code: 'CO', name: 'Colombia' },
  KM: { code: 'KM', name: 'Comoros' },
  CG: { code: 'CG', name: 'Congo' },
  CD: { code: 'CD', name: 'Congo, Democratic Republic' },
  CK: { code: 'CK', name: 'Cook Islands' },
  CR: { code: 'CR', name: 'Costa Rica' },
  CI: { code: 'CI', name: "Cote D'Ivoire" },
  HR: { code: 'HR', name: 'Croatia' },
  CU: { code: 'CU', name: 'Cuba' },
  CW: { code: 'CW', name: 'Curacao' },
  CY: { code: 'CY', name: 'Cyprus' },
  CZ: { code: 'CZ', name: 'Czech Republic' },
  DK: { code: 'DK', name: 'Denmark' },
  DJ: { code: 'DJ', name: 'Djibouti' },
  DM: { code: 'DM', name: 'Dominica' },
  DO: { code: 'DO', name: 'Dominican Republic' },
  EC: { code: 'EC', name: 'Ecuador' },
  EG: { code: 'EG', name: 'Egypt' },
  SV: { code: 'SV', name: 'El Salvador' },
  GQ: { code: 'GQ', name: 'Equatorial Guinea' },
  ER: { code: 'ER', name: 'Eritrea' },
  EE: { code: 'EE', name: 'Estonia' },
  ET: { code: 'ET', name: 'Ethiopia' },
  FK: { code: 'FK', name: 'Falkland Islands (Malvinas)' },
  FO: { code: 'FO', name: 'Faroe Islands' },
  FJ: { code: 'FJ', name: 'Fiji' },
  FI: { code: 'FI', name: 'Finland' },
  FR: { code: 'FR', name: 'France' },
  GF: { code: 'GF', name: 'French Guiana' },
  PF: { code: 'PF', name: 'French Polynesia' },
  GA: { code: 'GA', name: 'Gabon' },
  GM: { code: 'GM', name: 'Gambia' },
  GE: { code: 'GE', name: 'Georgia' },
  DE: { code: 'DE', name: 'Germany' },
  GH: { code: 'GH', name: 'Ghana' },
  GI: { code: 'GI', name: 'Gibraltar' },
  GR: { code: 'GR', name: 'Greece' },
  GL: { code: 'GL', name: 'Greenland' },
  GD: { code: 'GD', name: 'Grenada' },
  GP: { code: 'GP', name: 'Guadeloupe' },
  GU: { code: 'GU', name: 'Guam' },
  GT: { code: 'GT', name: 'Guatemala' },
  GG: { code: 'GG', name: 'Guernsey' },
  GN: { code: 'GN', name: 'Guinea' },
  GW: { code: 'GW', name: 'Guinea-Bissau' },
  GY: { code: 'GY', name: 'Guyana' },
  HT: { code: 'HT', name: 'Haiti' },
  VA: { code: 'VA', name: 'Holy See (Vatican City State)' },
  HN: { code: 'HN', name: 'Honduras' },
  HK: { code: 'HK', name: 'Hong Kong' },
  HU: { code: 'HU', name: 'Hungary' },
  IS: { code: 'IS', name: 'Iceland' },
  IN: { code: 'IN', name: 'India' },
  ID: { code: 'ID', name: 'Indonesia' },
  IR: { code: 'IR', name: 'Iran, Islamic Republic Of' },
  IQ: { code: 'IQ', name: 'Iraq' },
  IE: { code: 'IE', name: 'Ireland' },
  IM: { code: 'IM', name: 'Isle Of Man' },
  IL: { code: 'IL', name: 'Israel' },
  IT: { code: 'IT', name: 'Italy' },
  JM: { code: 'JM', name: 'Jamaica' },
  JP: { code: 'JP', name: 'Japan' },
  JE: { code: 'JE', name: 'Jersey' },
  JO: { code: 'JO', name: 'Jordan' },
  KZ: { code: 'KZ', name: 'Kazakhstan' },
  KE: { code: 'KE', name: 'Kenya' },
  KI: { code: 'KI', name: 'Kiribati' },
  XK: { code: 'XK', name: 'Kosovo' },
  KW: { code: 'KW', name: 'Kuwait' },
  KG: { code: 'KG', name: 'Kyrgyzstan' },
  LA: { code: 'LA', name: "Lao People's Democratic Republic" },
  LV: { code: 'LV', name: 'Latvia' },
  LB: { code: 'LB', name: 'Lebanon' },
  LS: { code: 'LS', name: 'Lesotho' },
  LR: { code: 'LR', name: 'Liberia' },
  LY: { code: 'LY', name: 'Libyan Arab Jamahiriya' },
  LI: { code: 'LI', name: 'Liechtenstein' },
  LT: { code: 'LT', name: 'Lithuania' },
  LU: { code: 'LU', name: 'Luxembourg' },
  MO: { code: 'MO', name: 'Macao' },
  MK: { code: 'MK', name: 'Macedonia' },
  MG: { code: 'MG', name: 'Madagascar' },
  MW: { code: 'MW', name: 'Malawi' },
  MY: { code: 'MY', name: 'Malaysia' },
  MV: { code: 'MV', name: 'Maldives' },
  ML: { code: 'ML', name: 'Mali' },
  MT: { code: 'MT', name: 'Malta' },
  MH: { code: 'MH', name: 'Marshall Islands' },
  MQ: { code: 'MQ', name: 'Martinique' },
  MR: { code: 'MR', name: 'Mauritania' },
  MU: { code: 'MU', name: 'Mauritius' },
  YT: { code: 'YT', name: 'Mayotte' },
  MX: { code: 'MX', name: 'Mexico' },
  FM: { code: 'FM', name: 'Micronesia, Federated States Of' },
  MD: { code: 'MD', name: 'Moldova' },
  MC: { code: 'MC', name: 'Monaco' },
  MN: { code: 'MN', name: 'Mongolia' },
  ME: { code: 'ME', name: 'Montenegro' },
  MS: { code: 'MS', name: 'Montserrat' },
  MA: { code: 'MA', name: 'Morocco' },
  MZ: { code: 'MZ', name: 'Mozambique' },
  MM: { code: 'MM', name: 'Myanmar' },
  NA: { code: 'NA', name: 'Namibia' },
  NR: { code: 'NR', name: 'Nauru' },
  NP: { code: 'NP', name: 'Nepal' },
  NL: { code: 'NL', name: 'Netherlands' },
  NC: { code: 'NC', name: 'New Caledonia' },
  NZ: { code: 'NZ', name: 'New Zealand' },
  NI: { code: 'NI', name: 'Nicaragua' },
  NE: { code: 'NE', name: 'Niger' },
  NG: { code: 'NG', name: 'Nigeria' },
  NU: { code: 'NU', name: 'Niue' },
  NF: { code: 'NF', name: 'Norfolk Island' },
  MP: { code: 'MP', name: 'Northern Mariana Islands' },
  KP: { code: 'KP', name: 'North Korea' },
  NO: { code: 'NO', name: 'Norway' },
  OM: { code: 'OM', name: 'Oman' },
  PK: { code: 'PK', name: 'Pakistan' },
  PW: { code: 'PW', name: 'Palau' },
  PS: { code: 'PS', name: 'Palestinian Territory, Occupied' },
  PA: { code: 'PA', name: 'Panama' },
  PG: { code: 'PG', name: 'Papua New Guinea' },
  PY: { code: 'PY', name: 'Paraguay' },
  PE: { code: 'PE', name: 'Peru' },
  PH: { code: 'PH', name: 'Philippines' },
  PL: { code: 'PL', name: 'Poland' },
  PT: { code: 'PT', name: 'Portugal' },
  PR: { code: 'PR', name: 'Puerto Rico' },
  QA: { code: 'QA', name: 'Qatar' },
  RE: { code: 'RE', name: 'Reunion' },
  RO: { code: 'RO', name: 'Romania' },
  RU: { code: 'RU', name: 'Russian Federation' },
  RW: { code: 'RW', name: 'Rwanda' },
  BL: { code: 'BL', name: 'Saint Barthelemy' },
  SH: { code: 'SH', name: 'Saint Helena' },
  KN: { code: 'KN', name: 'Saint Kitts And Nevis' },
  LC: { code: 'LC', name: 'Saint Lucia' },
  MF: { code: 'MF', name: 'Saint Martin' },
  PM: { code: 'PM', name: 'Saint Pierre And Miquelon' },
  VC: { code: 'VC', name: 'Saint Vincent And Grenadines' },
  WS: { code: 'WS', name: 'Samoa' },
  SM: { code: 'SM', name: 'San Marino' },
  ST: { code: 'ST', name: 'Sao Tome And Principe' },
  SA: { code: 'SA', name: 'Saudi Arabia' },
  SN: { code: 'SN', name: 'Senegal' },
  RS: { code: 'RS', name: 'Serbia' },
  SC: { code: 'SC', name: 'Seychelles' },
  SL: { code: 'SL', name: 'Sierra Leone' },
  SG: { code: 'SG', name: 'Singapore' },
  SX: { code: 'SX', name: 'Sint Maarten' },
  SK: { code: 'SK', name: 'Slovakia' },
  SI: { code: 'SI', name: 'Slovenia' },
  SB: { code: 'SB', name: 'Solomon Islands' },
  SO: { code: 'SO', name: 'Somalia' },
  ZA: { code: 'ZA', name: 'South Africa' },
  KR: { code: 'KR', name: 'South Korea' },
  SS: { code: 'SS', name: 'South Sudan' },
  ES: { code: 'ES', name: 'Spain' },
  LK: { code: 'LK', name: 'Sri Lanka' },
  SD: { code: 'SD', name: 'Sudan' },
  SR: { code: 'SR', name: 'Suriname' },
  SJ: { code: 'SJ', name: 'Svalbard And Jan Mayen' },
  SZ: { code: 'SZ', name: 'Swaziland' },
  SE: { code: 'SE', name: 'Sweden' },
  CH: { code: 'CH', name: 'Switzerland' },
  SY: { code: 'SY', name: 'Syrian Arab Republic' },
  TW: { code: 'TW', name: 'Taiwan' },
  TJ: { code: 'TJ', name: 'Tajikistan' },
  TZ: { code: 'TZ', name: 'Tanzania' },
  TH: { code: 'TH', name: 'Thailand' },
  TL: { code: 'TL', name: 'Timor-Leste' },
  TG: { code: 'TG', name: 'Togo' },
  TK: { code: 'TK', name: 'Tokelau' },
  TO: { code: 'TO', name: 'Tonga' },
  TT: { code: 'TT', name: 'Trinidad And Tobago' },
  TA: { code: 'TA', name: 'Tristan da Cunha' },
  TN: { code: 'TN', name: 'Tunisia' },
  TR: { code: 'TR', name: 'Turkey' },
  TM: { code: 'TM', name: 'Turkmenistan' },
  TC: { code: 'TC', name: 'Turks And Caicos Islands' },
  TV: { code: 'TV', name: 'Tuvalu' },
  UG: { code: 'UG', name: 'Uganda' },
  UA: { code: 'UA', name: 'Ukraine' },
  AE: { code: 'AE', name: 'United Arab Emirates' },
  GB: { code: 'GB', name: 'United Kingdom' },
  US: { code: 'US', name: 'United States' },
  UY: { code: 'UY', name: 'Uruguay' },
  UZ: { code: 'UZ', name: 'Uzbekistan' },
  VU: { code: 'VU', name: 'Vanuatu' },
  VE: { code: 'VE', name: 'Venezuela' },
  VN: { code: 'VN', name: 'Viet Nam' },
  VG: { code: 'VG', name: 'Virgin Islands, British' },
  VI: { code: 'VI', name: 'Virgin Islands, U.S.' },
  WF: { code: 'WF', name: 'Wallis And Futuna' },
  EH: { code: 'EH', name: 'Western Sahara' },
  YE: { code: 'YE', name: 'Yemen' },
  ZM: { code: 'ZM', name: 'Zambia' },
  ZW: { code: 'ZW', name: 'Zimbabwe' },
}

export const REQUIRED_FIELD = 'This field is required'

// TODO: Save breakpoints' values in an scss file and export them to js
export const BREAKPOINTS = {
  SMALL: 703,
  MEDIUM: 1023,
  LARGE: 1439,
}

export const BRAZILIAN_STATES = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goías' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraíma' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' },
]

export const MONTHS = [
  { value: '0', name: 'January', label: 'Jan' },
  { value: '1', name: 'February', label: 'Feb' },
  { value: '2', name: 'March', label: 'Mar' },
  { value: '3', name: 'April', label: 'Apr' },
  { value: '4', name: 'May', label: 'May' },
  { value: '5', name: 'June', label: 'Jun' },
  { value: '6', name: 'July', label: 'Jul' },
  { value: '7', name: 'August', label: 'Aug' },
  { value: '8', name: 'September', label: 'Sep' },
  { value: '9', name: 'October', label: 'Oct' },
  { value: '10', name: 'November', label: 'Nov' },
  { value: '11', name: 'December', label: 'Dec' },
]

export const PLATFORM_NAME = 'Olby'

export const PLATFORM_FINANCIAL_ENTITY = {
  name: 'Jungle Network, Inc.', // TODO: This name should be checked later
  email: 'rodrigo@olby.com',
  cnpj: '12.345.678/0000-00',
  streetNumber: '12890',
  street: 'Cross Point Dr',
  addressComplement: null,
  city: 'Frisco',
  state: 'TX',
  postalCode: '75033',
  country: 'United States',
}

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
}

export const JUNGLE_SUPPORT_EMAIL = 'support@olby.com'
export const JUNGLE_TALENT_SUPPORT_EMAIL = 'talents@olby.com'
export const JUNGLE_FINANCIAL_SUPPORT_EMAIL = 'financial@olby.com'
export const PLATFORM_WEBSITE_URL = 'https://talent.olby.com'
export const COMPANY_WEBSITE_URL = 'https://company.olby.com'

export const TALENT_PREFERRED_ROLES = {
  [ProfilePreferredRole.Backend]: 'Backend',
  [ProfilePreferredRole.Frontend]: 'Frontend',
  [ProfilePreferredRole.Mobile]: 'Mobile',
  [ProfilePreferredRole.Fullstack]: 'Full-Stack',
  [ProfilePreferredRole.QaEngineer]: 'QA Engineer',
  [ProfilePreferredRole.Devops]: 'DevOps',
  [ProfilePreferredRole.Design]: 'Design',
  [ProfilePreferredRole.Management]: 'Management',
}

export const PRE_SIGNED_URL_REFETCH_INTERVAL = 1000 * 60 * 25 // milliseconds * seconds * minute

export const ONE_HOUR_IN_SECONDS = 3600

export const BI_WEEKLY = 2

export const WORKABLE_STAGES = {
  SOURCED: 'Sourced',
  APPLIED: 'Applied',
  INITIAL_INTERVIEW: 'Initial interview',
  ENGLISH_ASSESSMENT: 'English assessment',
  TECHNICAL_CHALLENGE: 'Technical challenge',
  TECHNICAL_INTERVIEW: 'Technical interview',
  DISQUALIFIED: '🚫DISQUALIFIED🚫',
  FILL_PROFILE: 'Fill profile',
  HIRED: 'Hired',
  WAIT_LIST: 'Waitlist',
}

export const WORKABLE_STAGES_FORMATTED = {
  [WORKABLE_STAGES.SOURCED]: WORKABLE_STAGES.INITIAL_INTERVIEW,
  [WORKABLE_STAGES.APPLIED]: WORKABLE_STAGES.INITIAL_INTERVIEW,
  [WORKABLE_STAGES.ENGLISH_ASSESSMENT]: WORKABLE_STAGES.TECHNICAL_CHALLENGE,
  [WORKABLE_STAGES.INITIAL_INTERVIEW]: WORKABLE_STAGES.INITIAL_INTERVIEW,
  [WORKABLE_STAGES.TECHNICAL_CHALLENGE]: WORKABLE_STAGES.TECHNICAL_CHALLENGE,
  [WORKABLE_STAGES.TECHNICAL_INTERVIEW]: WORKABLE_STAGES.TECHNICAL_INTERVIEW,
}

export const WORKABLE_STAGES_FORMATTED_BACKOFFICE = {
  ...WORKABLE_STAGES_FORMATTED,
  [WORKABLE_STAGES.FILL_PROFILE]: WORKABLE_STAGES.FILL_PROFILE,
  [WORKABLE_STAGES.DISQUALIFIED]: WORKABLE_STAGES.DISQUALIFIED,
  [WORKABLE_STAGES.ENGLISH_ASSESSMENT]: WORKABLE_STAGES.ENGLISH_ASSESSMENT,
  [WORKABLE_STAGES.SOURCED]: WORKABLE_STAGES.SOURCED,
  [WORKABLE_STAGES.APPLIED]: WORKABLE_STAGES.APPLIED,
}

export const WORKABLE_STAGES_OPTIONS = [
  { label: WORKABLE_STAGES.WAIT_LIST, value: WORKABLE_STAGES.WAIT_LIST },
  { label: WORKABLE_STAGES.INITIAL_INTERVIEW, value: WORKABLE_STAGES.INITIAL_INTERVIEW },
  { label: WORKABLE_STAGES.TECHNICAL_CHALLENGE, value: WORKABLE_STAGES.TECHNICAL_CHALLENGE },
  { label: WORKABLE_STAGES.TECHNICAL_INTERVIEW, value: WORKABLE_STAGES.TECHNICAL_INTERVIEW },
  { label: WORKABLE_STAGES.FILL_PROFILE, value: WORKABLE_STAGES.FILL_PROFILE },
]

export const TALENT_PREFERRED_ROLE_OPTIONS = [
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Backend],
    value: ProfilePreferredRole.Backend,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Frontend],
    value: ProfilePreferredRole.Frontend,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Mobile],
    value: ProfilePreferredRole.Mobile,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Fullstack],
    value: ProfilePreferredRole.Fullstack,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.QaEngineer],
    value: ProfilePreferredRole.QaEngineer,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Devops],
    value: ProfilePreferredRole.Devops,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Design],
    value: ProfilePreferredRole.Design,
  },
  {
    label: TALENT_PREFERRED_ROLES[ProfilePreferredRole.Management],
    value: ProfilePreferredRole.Management,
  },
]
